import { InteractiveContainer } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import React from "react";

export const ConversationTab: React.FC<{
  isSelected: boolean;
  label: string;
  onSelect: () => void;
}> = ({ isSelected, label, onSelect }) => (
  <InteractiveContainer
    className={cx(
      "flex h-8 w-full items-center justify-center gap-1 rounded-lg transition-colors",
      isSelected ? "bg-primary" : "bg-grey-100"
    )}
    onClick={onSelect}
  >
    <span
      className={cx(
        "font-secondary leading-2 text-[13px] transition-colors",
        isSelected ? "font-medium text-white" : "text-dark-700"
      )}
    >
      {label}
    </span>
  </InteractiveContainer>
);
